import $ from 'cash-dom'

export default class SliderController {
  constructor({ $container, splide } = {}) {
    this.$container = $container
    this.splide = splide

    this.constructElements()

    this.constructEvents()
  }

  constructElements() {
    this.$buttonNext = this.$container.find(SliderController.selectors.buttonNext)
    this.$buttonPrev = this.$container.find(SliderController.selectors.buttonPrev)
  }

  constructEvents() {
    this.$container
      .on('click', SliderController.selectors.buttonNext, this.handleClickButtonNext.bind(this))
      .on('click', SliderController.selectors.buttonPrev, this.handleClickButtonPrev.bind(this))
  }

  handleClickButtonNext(e) {
    e.preventDefault()

    this.splide.go('+1')
  }

  handleClickButtonPrev(e) {
    e.preventDefault()

    this.splide.go('-1')
  }
}

SliderController.selectors = {
  buttonNext: '.js-slider-button-next',
  buttonPrev: '.js-slider-button-prev',
}
